import Image from "next/image";

function PhotoSlide({ slide, i, card, aktual }) {
  return (
    <div
      ref={card}
      key={i}
      className={`relative transition-all duration-1000 md:first:ml-[22rem] ${aktual === i ? "h-[20rem] w-[20rem] opacity-100 grayscale-0 md:h-[30rem] md:w-[30rem]" : "h-60 w-60 opacity-20 grayscale md:h-80 md:w-80"} `}
      // style={{
      //   transform: `translateX(${ml.current}px)`,
      // }}
      // style={{
      //   transform: `${aktual === 0 ? `translateX(${ml.current}px)` : ``}`,
      // }}
    >
      <Image
        fill
        alt="foto z akce"
        src={`${process.env.NEXT_PUBLIC_STRAPI_URL}${slide.url}`}
        className="object-contain"
        unoptimized
      />
    </div>
  );
}
export default PhotoSlide;
